import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, catchError, map, of, throwError } from 'rxjs';
import { OfficerInfo, ReqLogin } from 'src/app/models/api-response';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  offdefault: OfficerInfo = {
    officerId: '',
    officerName: '',
    officerLastName: '',
    isAdmin: 0,
    isLibrarian: 0,
    token: ''
  }
  public officerInfo = signal<OfficerInfo>(this.offdefault);
  private officerInfo$: BehaviorSubject<OfficerInfo>;

  constructor(private http: HttpClient, private router: Router,) {
    if (localStorage.getItem('currentOfficerInfo') == undefined) {
      localStorage.removeItem('currentOfficerInfo');
      this.officerInfo$ = new BehaviorSubject<OfficerInfo>(this.offdefault);
      //console.log(1)
    } else {
      //console.log(2)
      this.offdefault = JSON.parse(localStorage.getItem('currentOfficerInfo') ?? '')
      this.officerInfo$ = new BehaviorSubject<OfficerInfo>(JSON.parse(localStorage.getItem('currentOfficerInfo') ?? ''));
    }

  }
  public get currentWalaiUserValue(): OfficerInfo {
    return this.officerInfo$.value;
  }
  handleError(error: HttpErrorResponse): Observable<never> {
    console.log(error.message);
    return throwError(() => new Error(error.message));
  }

  public loadDataLogin(val: ReqLogin): Observable<any> {
    // console.log(JSON.stringify(val));
    let results: OfficerInfo
    return this.http.post<any>(`${environment.apiUrl}/${environment.basePath}/api/Login`, val,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/json'
        ), observe: 'response'
      }).pipe(map(user => {
        let body = user.body;
        results = body.results
        localStorage.setItem('currentOfficerInfo', JSON.stringify(results));
        this.officerInfo$!.next(results)
        return user
      }), catchError(this.handleError));
  }
  public logout() {
    this.offdefault = {
      officerId: '',
      officerName: '',
      officerLastName: '',
      isAdmin: 0,
      isLibrarian: 0,
      token: ''
    }
    localStorage.setItem('currentOfficerInfo', JSON.stringify(this.offdefault));
    this.officerInfo$!.next(this.offdefault)
    this.router.navigate(['/login']);
  }
  // return this.http.post<ResWalaiOfficerLogin>(`${this.walaiApiUrl}/login`, login)
  //     .pipe(map(user => {
  //       // console.log(user)
  //       localStorage.setItem('currentWalaiUser', JSON.stringify(user));
  //       this.currentWalaiUserSubject.next(user);
  //       return user;
  //     }));
}
